module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/227-senegal-9f55b4bd43c26e91e62c6b63466a7cd5.svg";